import { z } from "zod"
import { LegacyCompatibleDiscountSchema } from "./discount"
import {
  EvaluatedServiceBikePartSchema,
  ManualServiceActionSchema,
  PartGrade,
  ServiceBikeGearSystem,
  ServiceBikeType,
} from "./index"

export const GenerateServiceProposalPreviewSchema = z.object({
  feeIds: z.array(z.guid()),
  originalWashId: z.guid().optional(),
  washLaborPriceDiscount: LegacyCompatibleDiscountSchema.nullable().optional(),
  customerIsClubMember: z.boolean(),
  storeId: z.guid(),
  bikeType: z.nativeEnum(ServiceBikeType),
  bikeIsElectric: z.boolean().nullable(),
  bikeGearSystem: z.nativeEnum(ServiceBikeGearSystem).nullable().default(null),
  // The reception's preview sends components it never graded.
  evaluatedParts: z.array(
    EvaluatedServiceBikePartSchema.extend({
      grade: z.nativeEnum(PartGrade).nullable().default(null),
    }),
  ),
  manualServiceActions: z.array(ManualServiceActionSchema),
  packageDiscounts: z
    .record(z.guid(), LegacyCompatibleDiscountSchema.nullable())
    .optional(),
  selectedPackageIds: z.array(z.guid()).optional(),
  priceListId: z.guid().optional(),
  /** The job's leasing company labels, which decide the packages it may get. */
  leasingCompanyIds: z.array(z.guid()).default([]),
  extraPackagePartActions: z
    .array(
      z.object({
        packageId: z.guid(),
        partId: z.guid(),
      }),
    )
    .optional(),
})
export type GenerateServiceProposalPreview = z.infer<
  typeof GenerateServiceProposalPreviewSchema
>
